import { buildAction } from 'store/actions/actionCreator'

import { CHANGE_DATE, SELECT_DATE_RANGE, TOGGLE_DATE_PICKER_DIALOG } from './constants'

export const changeDate = buildAction(CHANGE_DATE, 'payload')

export const toggleDatePickerDialog = buildAction(TOGGLE_DATE_PICKER_DIALOG)

export const selectDateRange = buildAction(SELECT_DATE_RANGE, 'payload')
